import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ip-shared-translucent-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './translucent-card.component.html',
  styleUrl: './translucent-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslucentCardComponent {
  @Input() height = '125px';
  @Input() weight = '125px';

  style: { [p: string]: string } = {};
}
